export const styles = {
  app: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    minHeight: '100vh',
    background: 'var(--page-bg)',
    transition: 'background 0.3s',
  },
  header: {
    background: 'var(--header-gradient)',
    color: 'white',
    padding: '0 24px',
    boxShadow: 'var(--shadow-header)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  headerInner: {
    maxWidth: 1400,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
  },
  headerBrand: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  headerIcon: {
    flexShrink: 0,
  },
  headerTitle: {
    margin: 0,
    fontFamily: "'Cinzel', serif",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: '0.5px',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  shareWrap: {
    position: 'relative',
  },
  shareBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '7px 18px',
    background: 'rgba(255,255,255,0.25)',
    color: 'white',
    border: '1px solid rgba(255,255,255,0.4)',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 13,
    fontFamily: "'Inter', sans-serif",
    transition: 'all 0.2s',
    backdropFilter: 'blur(4px)',
    minWidth: 72,
  },
  shareInfo: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 15,
    height: 15,
    borderRadius: '50%',
    border: '1.5px solid rgba(255,255,255,0.6)',
    fontSize: 9,
    fontWeight: 700,
    lineHeight: 1,
    opacity: 0.7,
  },
  shareTooltip: {
    display: 'none',
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: 6,
    padding: '10px 14px',
    background: 'var(--card-bg, #fff)',
    color: 'var(--text-body, #333)',
    borderRadius: 10,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.5,
    width: 240,
    boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
    border: '1px solid var(--border-main, #ddd)',
    zIndex: 200,
    pointerEvents: 'none',
  },
  newGameBtn: {
    padding: '7px 18px',
    background: 'rgba(255,255,255,0.15)',
    color: 'white',
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 13,
    fontFamily: "'Inter', sans-serif",
    transition: 'all 0.2s',
    backdropFilter: 'blur(4px)',
  },
  themeBtn: {
    padding: '5px 8px',
    background: 'rgba(255,255,255,0.15)',
    border: '1px solid rgba(255,255,255,0.3)',
    borderRadius: 8,
    cursor: 'pointer',
    fontSize: 16,
    lineHeight: 1,
    transition: 'all 0.2s',
  },
  main: {
    padding: '24px 12px 60px',
    maxWidth: 1400,
    margin: '0 auto',
  },
  toastContainer: {
    position: 'fixed',
    bottom: 20,
    right: 20,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxWidth: 380,
  },
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 16px',
    background: 'var(--error-bg)',
    color: 'var(--error-text)',
    border: '1px solid var(--error-border)',
    borderRadius: 12,
    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
    fontSize: 13,
    fontWeight: 500,
    fontFamily: "'Inter', sans-serif",
    lineHeight: 1.4,
  },
  toastIcon: {
    fontSize: 16,
    flexShrink: 0,
  },
  toastMsg: {
    flex: 1,
  },
  toastClose: {
    background: 'none',
    border: 'none',
    color: 'var(--error-text)',
    fontSize: 18,
    cursor: 'pointer',
    padding: '0 2px',
    opacity: 0.6,
    flexShrink: 0,
    lineHeight: 1,
  },
  loadingWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 80,
  },
  spinner: {
    width: 32,
    height: 32,
    border: '3px solid var(--border-light)',
    borderTopColor: 'var(--text-secondary)',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
  toolbarBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    border: 'none',
    borderRadius: 8,
    background: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.15s',
    color: 'var(--text-body)',
    padding: 0,
  },
  toolbarBtnDisabled: {
    opacity: 0.3,
    cursor: 'default',
  },
  toolbarDivider: {
    width: 1,
    height: 20,
    background: 'var(--border-main)',
  },
  notFoundWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
  },
  notFoundCard: {
    textAlign: 'center',
    background: 'var(--card-bg)',
    borderRadius: 16,
    padding: '48px 40px',
    boxShadow: 'var(--shadow-card)',
    border: '1px solid var(--border-subtle)',
    maxWidth: 420,
    width: '100%',
  },
  notFoundIcon: {
    fontSize: 64,
    marginBottom: 16,
    filter: 'grayscale(0.3)',
  },
  notFoundTitle: {
    margin: '0 0 8px',
    fontSize: 24,
    fontWeight: 700,
    color: 'var(--text-primary)',
    fontFamily: "'Inter', sans-serif",
  },
  notFoundText: {
    margin: '0 0 28px',
    fontSize: 15,
    color: 'var(--text-muted)',
    lineHeight: 1.5,
  },
  notFoundBtn: {
    padding: '12px 32px',
    background: 'var(--header-gradient)',
    color: 'white',
    border: 'none',
    borderRadius: 10,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 15,
    fontFamily: "'Inter', sans-serif",
    transition: 'all 0.2s',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
};
